(function () {
  const NORMAL_AUTO_INTERVAL = 10;
  const INTERACTION_INTERVAL = 20;
  let timers = new Map();
  let currentIndices = new Map();
  let sectionVisibility = new Map();

  const clearTimer = (section) => {
    if (timers.has(section)) {
      const id = timers.get(section);
      clearInterval(id);
      clearTimeout(id);
      timers.delete(section);
    }
  };

  const setImageClasses = (section, activeId) => {
    const images = section.querySelectorAll(".image-tabs__image");

    images.forEach((image) => {
      image.classList.remove("image-tabs__image--active");
    });

    const activeImage = section.querySelector(
      `[data-image-tabs="${activeId}"].image-tabs__image`
    );

    activeImage.classList.add("image-tabs__image--active");
  };

  const cycleToNext = (section) => {
    const blocks = section.querySelectorAll(".image-tabs__block");
    let index = currentIndices.get(section) || 0;
    index = (index + 1) % blocks.length;
    currentIndices.set(section, index);
    const activeBlock = blocks[index];
    const activeId = activeBlock.dataset.imageTabs;
    blocks.forEach((block) => {
      block.classList.remove("image-tabs__block--active");
      block.classList.remove("active");
    });
    activeBlock.classList.add("image-tabs__block--active");
    activeBlock.classList.add("active");
    setImageClasses(section, activeId);
    scrollToActive(section);
  };

  const scrollToActive = (section) => {
    if (window.innerWidth <= 989) {
      const activeBlock = document.querySelector('.image-tabs__block--active');
      if (activeBlock) {
        const parent = activeBlock.closest('.image-tabs__content-blocks-wrapper');
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          const childRect = activeBlock.getBoundingClientRect();
          const scrollLeft =
            parent.scrollLeft +
            (childRect.left - parentRect.left) -
            parentRect.width / 2 +
            childRect.width / 2;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth'
          });
        }
      }
    }
  };

  const startTimer = (section) => {
    if (!sectionVisibility.get(section)) return;
    clearTimer(section);
    const timerId = setInterval(() => {
      cycleToNext(section);
    }, NORMAL_AUTO_INTERVAL * 1000);
    timers.set(section, timerId);
  };

  const startInteractionTimer = (section) => {
    clearTimer(section);
    const timerId = setTimeout(() => {
      cycleToNext(section);
      startTimer(section);
    }, INTERACTION_INTERVAL * 1000);
    timers.set(section, timerId);
  };

  const initClassesDesktop = (section) => {
    const blocks = section.querySelectorAll(".image-tabs__block");
    if (blocks.length > 0) {
      currentIndices.set(section, 0);
      blocks[0].classList.add("image-tabs__block--active");
      blocks[0].classList.add("active");
      setImageClasses(section, "#image-tabs-1");
      scrollToActive(section);
    }
  };

  const blockToggleDesktop = (section) => {
    const blocks = section.querySelectorAll(".image-tabs__block");

    const setBlockClasses = (activeBlock) => {
      blocks.forEach((block) => {
        block.classList.remove("image-tabs__block--active");
        block.classList.remove("active");
      });
      activeBlock.classList.add("image-tabs__block--active");
      activeBlock.classList.add("active");
    };

    blocks.forEach((block, index) => {
      block.addEventListener("click", () => {
        const activeId = block.dataset.imageTabs;
        setBlockClasses(block);
        setImageClasses(section, activeId);
        currentIndices.set(section, index);
        startInteractionTimer(section);
        scrollToActive(section);
      });

      block.addEventListener("mouseenter", () => {
        blocks.forEach((block) => {
          block.classList.remove("image-tabs__block--active");
          block.classList.remove("active");
        });
        const hoverId = block.dataset.imageTabs;
        block.classList.add("image-tabs__block--active");
        setImageClasses(section, hoverId);
        currentIndices.set(section, index);
        startInteractionTimer(section);
        scrollToActive(section);
      });
    });
  };

  const destroySlider = (section) => {
    clearTimer(section);
    const images = section.querySelectorAll(".image-tabs__image");
    const tabs = section.querySelectorAll(".image-tabs__block");
    const sliderTabs = section.querySelector(".swiper--content-tabs");
    const sliderImage = section.querySelector(".swiper--image-tabs");

    if (sliderTabs.swiper) sliderTabs.swiper.destroy();
    if (sliderImage.swiper) sliderImage.swiper.destroy();

    images.forEach((image) => {
      image.removeAttribute("style");
      image.classList.remove("swiper-slide");
    });
    tabs.forEach((tab) => {
      tab.removeAttribute("style");
      tab.classList.remove("swiper-slide");
    });
  };

  const setupVisibilityObserver = (section) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const isVisible = entry.intersectionRatio >= 0.5;
          sectionVisibility.set(section, isVisible);
          if (isVisible) {
            startTimer(section);
          } else {
            clearTimer(section);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );
    observer.observe(section);
  };

  const initSection = (section) => {
    if (section && section.classList.contains("image-tabs-section")) {
      sectionVisibility.set(section, false);
      initClassesDesktop(section);
      blockToggleDesktop(section);

      setupVisibilityObserver(section);

      const sectionResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          clearTimer(entry.target);
          destroySlider(entry.target);
          initClassesDesktop(entry.target);
          blockToggleDesktop(entry.target);
          startTimer(entry.target);
        });
      });

      sectionResizeObserver.observe(section);
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
